import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { PATHS, EXTERNAL_PATHS, SUPPORT_URLS } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import ResourceSection from 'src/safety/components/ResourceSection';
import styles from './RenterResource.module.scss';

const RenterResources: FC = () => {
  const [t] = useTranslation('safety-page');

  return (
    <PitchPageLayout backgroundColor="pearl">
      <div className={styles.root}>
        <ResourceSection
          eyebrow={t('resource--renter--eyebrow')}
          title={t('resource--renter--title')}
          text={t('resource--renter--text')}
          resourceListItems={[
            {
              iconId: 'boat',
              iconColor: 'bluminescence-01',
              title: t('resource--renter--item-0--title'),
              text: t('resource--renter--item-0--text'),
              linkText: t('resource--renter--item-0--linkText'),
              linkHref: PATHS.HOW_IT_WORKS,
            },
            {
              iconId: 'lifebuoy',
              iconColor: 'sunset',
              title: t('resource--renter--item-1--title'),
              text: t('resource--renter--item-1--text'),
              linkText: t('resource--renter--item-1--linkText'),
              linkHref: `${EXTERNAL_PATHS.JOURNAL}how-to/`,
            },
            {
              iconId: 'list-check',
              iconColor: 'sand',
              title: t('resource--renter--item-2--title'),
              text: t('resource--renter--item-2--text'),
              linkText: t('resource--renter--item-2--linkText'),
              linkHref: SUPPORT_URLS.WHAT_TO_BRING_ON_TRIP,
            },
          ]}
        />
      </div>
    </PitchPageLayout>
  );
};

export default RenterResources;
